import { ArrayUtils } from '@colonist/utils';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { ActionState, CardEnum } from '@colonist/game-states';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { CARD_POPUP_BODY } from '@colonist/ui-game';
export class UIGameInventorHighlightDiceController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.HighlightDiceNumbersForInventor:
                this.highlightDiceNumbers(data);
                break;
            case UIGameEventEnums.GameStateUpdated:
                this.gameStateUpdated();
                break;
            default:
                break;
        }
    }
    highlightDiceNumbers(highlightedIndexes) {
        const isAlreadyHighlighted = this.diceProbabilityViewsBeingHighlighted.length != 0;
        if (isAlreadyHighlighted) return;
        for (const highlightIndex of highlightedIndexes){
            const tileView = this.uiGameManager.mapController.tileViews[highlightIndex];
            if (tileView.probabilityView == undefined) continue;
            tileView.probabilityView.highlight();
            this.diceProbabilityViewsBeingHighlighted.push(tileView.probabilityView);
        }
        this.startAnimation();
        this.showInventorConfirmationPopup();
    }
    startAnimation() {
        this.animateDiceProbabilityViewsIfUnselected();
        this.setClickAction();
    }
    animateDiceProbabilityViewsIfUnselected() {
        for (const diceProbabilityView of this.diceProbabilityViewsBeingHighlighted){
            const diceProbabilityViewIsSelected = ArrayUtils.elementInArray(this.selectedDiceNumbers, diceProbabilityView);
            if (diceProbabilityViewIsSelected) continue;
            diceProbabilityView.resetAnimation();
            diceProbabilityView.animate();
        }
    }
    setClickAction() {
        for (const diceProbabilityView of this.diceProbabilityViewsBeingHighlighted){
            diceProbabilityView.eventMode = 'static';
            diceProbabilityView.on('pointerdown', ()=>{
                this.clickedDiceNumber(diceProbabilityView);
            });
        }
    }
    endAnimation() {
        for (const diceProbabilityView of this.diceProbabilityViewsBeingHighlighted)diceProbabilityView.resetAnimation();
        this.removeClickAction();
    }
    removeClickAction() {
        for (const diceProbabilityView of this.diceProbabilityViewsBeingHighlighted){
            diceProbabilityView.removeAllListeners('pointerdown');
        }
    }
    clickedDiceNumber(diceProbabilityView) {
        AudioManager.play(AudioType.Click);
        const alreadySelectedDiceView = ArrayUtils.elementInArray(this.selectedDiceNumbers, diceProbabilityView);
        if (alreadySelectedDiceView) {
            this.deselectDiceNumber(diceProbabilityView);
        } else {
            this.selectDiceNumber(diceProbabilityView);
        }
    }
    selectDiceNumber(diceProbabilityView) {
        const alreadySelectedTwoNumbers = this.selectedDiceNumbers.length == 2;
        if (alreadySelectedTwoNumbers) return;
        this.selectedDiceNumbers.push(diceProbabilityView);
        diceProbabilityView.removeHighlight();
        diceProbabilityView.resetAnimation();
        this.updateCheckButtonOpacity();
    }
    deselectDiceNumber(diceProbabilityView) {
        ArrayUtils.removeElementFromArray(this.selectedDiceNumbers, diceProbabilityView);
        this.animateDiceProbabilityViewsIfUnselected();
        diceProbabilityView.highlight();
        this.updateCheckButtonOpacity();
    }
    updateCheckButtonOpacity() {
        const hasActivePopup = this.uiGameManager.gameStore.getState().actionBox.actionBoxData != undefined;
        if (!hasActivePopup) return;
        const amountOfSelectDiceNumbers = this.selectedDiceNumbers.length;
        const isConfirmDisabled = amountOfSelectDiceNumbers !== 2;
        const currentActionBoxData = this.uiGameManager.gameStore.getState().actionBox.actionBoxData;
        if ((currentActionBoxData === null || currentActionBoxData === void 0 ? void 0 : currentActionBoxData.type) !== 'base') return;
        if (currentActionBoxData.props.isInfoOnly) return;
        this.uiGameManager.gameStore.getState().actionBox.setActionBoxData({
            ...currentActionBoxData,
            props: {
                ...currentActionBoxData.props,
                isConfirmDisabled: isConfirmDisabled
            }
        });
    }
    showInventorConfirmationPopup() {
        const hasActivePopup = this.uiGameManager.gameStore.getState().actionBox.actionBoxData != undefined;
        if (hasActivePopup) return;
        const cardConfirmationPopupFormat = {
            cardEnum: CardEnum.ProgressCardScienceInventor,
            cardBody: CARD_POPUP_BODY[CardEnum.ProgressCardScienceInventor],
            allowableActionState: ActionState.SelectTileProductionNumbersToSwap
        };
        const inventorPopupData = {
            onCheckAction: ()=>this.checkAction(),
            onCancelAction: ()=>this.cancelAction(),
            popupInformation: cardConfirmationPopupFormat
        };
        this.uiGameManager.eventController.sendEvent(inventorPopupData, UIGameEventEnums.SelectDiceNumbersConfirmation);
        this.updateCheckButtonOpacity();
    }
    checkAction() {
        const alreadySelectedTwoNumbers = this.selectedDiceNumbers.length == 2;
        if (!alreadySelectedTwoNumbers) return;
        const selectedTiles = this.getSelectedTileIndices();
        this.uiGameManager.socketGameSend.selectedTiles(selectedTiles);
        this.closeUI();
    }
    getSelectedTileIndices() {
        const selectedTileIndexs = [];
        for (const selectedDiceNumber of this.selectedDiceNumbers){
            const tileIndex = this.uiGameManager.gameState.mapState.tileState.getTileHexIndex(selectedDiceNumber.hexFace);
            if (tileIndex == undefined) continue;
            selectedTileIndexs.push(tileIndex);
        }
        return selectedTileIndexs;
    }
    cancelAction() {
        this.uiGameManager.socketGameSend.cancelAction();
        this.closeUI();
    }
    closeUI() {
        const hasActivePopup = this.uiGameManager.gameStore.getState().actionBox.actionBoxData != undefined;
        if (hasActivePopup) return;
        this.removeHighlights();
        this.endAnimation();
        this.selectedDiceNumbers = [];
        this.diceProbabilityViewsBeingHighlighted = [];
        this.uiGameManager.gameStore.getState().actionBox.hideActionBox();
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.PopupActive);
    }
    removeHighlights() {
        for (const diceProbabilityView of this.diceProbabilityViewsBeingHighlighted){
            diceProbabilityView.removeHighlight();
        }
    }
    gameStateUpdated() {
        if (this.uiGameManager.gameController.currentState.actionState == ActionState.SelectTileProductionNumbersToSwap) return;
        this.closeUI();
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.diceProbabilityViewsBeingHighlighted = [];
        this.selectedDiceNumbers = [];
    }
}
